import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Loader2, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { ssoCallback } from '../services/api';

export default function SSOCallbackPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const { setUser, setToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError('Авторизация отменена или произошла ошибка');
        return;
      }

      if (!code || !state) {
        setError('Отсутствуют необходимые параметры');
        return;
      }

      try {
        const response = await ssoCallback({ code, state });
        const { access_token, user } = response.data;

        // Set auth state
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));
        setToken(access_token);
        setUser(user);

        toast.success(`Добро пожаловать, ${user.full_name}!`);

        // Redirect based on role
        if (user.role === 'admin') {
          navigate('/admin');
        } else if (user.role === 'security') {
          navigate('/security');
        } else {
          navigate('/dashboard');
        }
      } catch (err) {
        console.error('SSO callback error:', err);
        setError(err.response?.data?.detail || 'Ошибка авторизации через SSO');
      }
    };

    handleCallback();
  }, [searchParams, navigate, setUser, setToken]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6">
            <div className="text-center space-y-4">
              <div className="mx-auto w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
                <AlertCircle className="h-6 w-6 text-destructive" />
              </div>
              <div>
                <h2 className="text-lg font-semibold">Ошибка авторизации</h2>
                <p className="text-sm text-muted-foreground mt-1">{error}</p>
              </div>
              <button
                onClick={() => navigate('/login')}
                className="text-primary hover:underline text-sm"
              >
                Вернуться на страницу входа
              </button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Shield className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Авторизация через SSO</h2>
              <p className="text-sm text-muted-foreground mt-1 flex items-center justify-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                Выполняется вход...
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
